/* tslint:disable */
/* eslint-disable */
/**
 * BusService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { GetBusMinPriceRequestDto } from '../model';
// @ts-ignore
import { GetBusMinPriceResponseDto } from '../model';
// @ts-ignore
import { MinPrice } from '../model';
/**
 * GetMinPricesApiApiGetBusMinPricePost - axios parameter creator
 * 
 * @param {GetBusMinPriceRequestDto} [getBusMinPriceRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetMinPricesApiApiGetBusMinPricePostAxiosParamCreator (getBusMinPriceRequestDto?: GetBusMinPriceRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetBusMinPrice`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getBusMinPriceRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GetMinPricesApiApiGetMinPricesGet - axios parameter creator
 * 
 * @param {number} [from] 
 * @param {number} [to] 
 * @param {string} [fromDate] 
 * @param {string} [toDate] 
 * @param {number} [capacity] 
 * @param {number} [providerId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetMinPricesApiApiGetMinPricesGetAxiosParamCreator (from?: number, to?: number, fromDate?: string, toDate?: string, capacity?: number, providerId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetMinPrices`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = to;
    }

    if (fromDate !== undefined) {
        localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
            (fromDate as any).toISOString() :
            fromDate;
    }

    if (toDate !== undefined) {
        localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
            (toDate as any).toISOString() :
            toDate;
    }

    if (capacity !== undefined) {
        localVarQueryParameter['capacity'] = capacity;
    }

    if (providerId !== undefined) {
        localVarQueryParameter['providerId'] = providerId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * GetMinPricesApiApiGetMinPricesV2Get - axios parameter creator
 * 
 * @param {number} [from] 
 * @param {number} [to] 
 * @param {string} [fromDate] 
 * @param {string} [toDate] 
 * @param {number} [capacity] 
 * @param {number} [providerId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetMinPricesApiApiGetMinPricesV2GetAxiosParamCreator (from?: number, to?: number, fromDate?: string, toDate?: string, capacity?: number, providerId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetMinPrices/v2`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (from !== undefined) {
        localVarQueryParameter['from'] = from;
    }

    if (to !== undefined) {
        localVarQueryParameter['to'] = to;
    }

    if (fromDate !== undefined) {
        localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
            (fromDate as any).toISOString() :
            fromDate;
    }

    if (toDate !== undefined) {
        localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
            (toDate as any).toISOString() :
            toDate;
    }

    if (capacity !== undefined) {
        localVarQueryParameter['capacity'] = capacity;
    }

    if (providerId !== undefined) {
        localVarQueryParameter['providerId'] = providerId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiGetBusMinPricePost operation in GetMinPricesApi.
 * @export
 * @interface GetMinPricesApiApiGetBusMinPricePostRequest
 */
export interface GetMinPricesApiApiGetBusMinPricePostRequest {
    /**
     * 
     * @type {GetBusMinPriceRequestDto}
     * @memberof GetMinPricesApiApiGetBusMinPricePost
     */
    readonly getBusMinPriceRequestDto?: GetBusMinPriceRequestDto
}

/**
 * Request parameters for apiGetMinPricesGet operation in GetMinPricesApi.
 * @export
 * @interface GetMinPricesApiApiGetMinPricesGetRequest
 */
export interface GetMinPricesApiApiGetMinPricesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof GetMinPricesApiApiGetMinPricesGet
     */
    readonly from?: number

    /**
     * 
     * @type {number}
     * @memberof GetMinPricesApiApiGetMinPricesGet
     */
    readonly to?: number

    /**
     * 
     * @type {string}
     * @memberof GetMinPricesApiApiGetMinPricesGet
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof GetMinPricesApiApiGetMinPricesGet
     */
    readonly toDate?: string

    /**
     * 
     * @type {number}
     * @memberof GetMinPricesApiApiGetMinPricesGet
     */
    readonly capacity?: number

    /**
     * 
     * @type {number}
     * @memberof GetMinPricesApiApiGetMinPricesGet
     */
    readonly providerId?: number
}

/**
 * Request parameters for apiGetMinPricesV2Get operation in GetMinPricesApi.
 * @export
 * @interface GetMinPricesApiApiGetMinPricesV2GetRequest
 */
export interface GetMinPricesApiApiGetMinPricesV2GetRequest {
    /**
     * 
     * @type {number}
     * @memberof GetMinPricesApiApiGetMinPricesV2Get
     */
    readonly from?: number

    /**
     * 
     * @type {number}
     * @memberof GetMinPricesApiApiGetMinPricesV2Get
     */
    readonly to?: number

    /**
     * 
     * @type {string}
     * @memberof GetMinPricesApiApiGetMinPricesV2Get
     */
    readonly fromDate?: string

    /**
     * 
     * @type {string}
     * @memberof GetMinPricesApiApiGetMinPricesV2Get
     */
    readonly toDate?: string

    /**
     * 
     * @type {number}
     * @memberof GetMinPricesApiApiGetMinPricesV2Get
     */
    readonly capacity?: number

    /**
     * 
     * @type {number}
     * @memberof GetMinPricesApiApiGetMinPricesV2Get
     */
    readonly providerId?: number
}

/**
* 
* @param {GetMinPricesApiApiGetBusMinPricePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetMinPricesApiApiGetBusMinPricePost(requestParameters: GetMinPricesApiApiGetBusMinPricePostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetMinPricesApiApiGetBusMinPricePostAxiosParamCreator(requestParameters.getBusMinPriceRequestDto, options, configuration);
    const request: () => AxiosPromise<GetBusMinPriceResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GetMinPricesApiApiGetMinPricesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetMinPricesApiApiGetMinPricesGet(requestParameters: GetMinPricesApiApiGetMinPricesGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetMinPricesApiApiGetMinPricesGetAxiosParamCreator(requestParameters.from, requestParameters.to, requestParameters.fromDate, requestParameters.toDate, requestParameters.capacity, requestParameters.providerId, options, configuration);
    const request: () => AxiosPromise<{ [key: string]: string; }> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {GetMinPricesApiApiGetMinPricesV2GetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetMinPricesApiApiGetMinPricesV2Get(requestParameters: GetMinPricesApiApiGetMinPricesV2GetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetMinPricesApiApiGetMinPricesV2GetAxiosParamCreator(requestParameters.from, requestParameters.to, requestParameters.fromDate, requestParameters.toDate, requestParameters.capacity, requestParameters.providerId, options, configuration);
    const request: () => AxiosPromise<Array<MinPrice>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
